import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { Container, Row, Col, Modal } from 'react-bootstrap';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { GETTYPECODE, GETOWNERCODE, GETCONDITIONCODE, EDITULDSTOCK, GETDESTINATION } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';

const EditUld = ({ onClose, reloadEdit, edit_data }) => {
    console.log('edit_data', edit_data);

    const isMounted = useRef(false);
    const [modalShow, setModalShow] = useState(true);
    const [editFormData, setEditFormData] = useState({});

    const [getTypeCodes, setGetTypeCodes] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [getCondCodes, setGetCondCode] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);
    const fetchData = async () => {
        try {

            const res = await withRFSToken.post(GETTYPECODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.uld_typecode,
                        label: item.uld_typecode
                    })) : [];
                    setGetTypeCodes(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCondCode = async () => {
        try {

            const res = await withRFSToken.post(GETCONDITIONCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setGetCondCode(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        fetchData();
        fetchOwnerCode();
        fetchCondCode();
        fetchDestination();
        setEditFormData(edit_data);
        isMounted.current = true;
    }, []);

    useEffect(() => {
        console.log('selectedDestinationHandler', selectedDestinationHandler);
        console.log('selectedDestinationHandler', selectedDestinationHandler);

        if (editFormData.destination) {

            const selectedDestination = getDestination.find(option => option.value === editFormData.destination);
            console.log("🚀 ~ useEffect ~ selectedDestination:", selectedDestination)
            if (selectedDestination) {
                setDestinationHandler(selectedDestination.address);
                setSelectedDestinationId(selectedDestination.station_id);
                if (editFormData.handler_name_id) {
                    const selectedOH = selectedDestination.address.find(option => option.id === editFormData.handler_name_id)
                    if (selectedOH) {
                        setSelectedDestinationHandler({ value: selectedOH.id, label: selectedOH.company_name })
                    }
                }
                // setSelectedDestinationHandler(null);
            } else {
                setDestinationHandler([]);
                setSelectedDestinationId(null);
                // setSelectedDestinationHandler(null);
            }
        };
    }, [editFormData, getDestination])

    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    const handleEditChange = (e) => {
        const { name, value: rawValue, type, checked } = e.target;
        let value = rawValue;
        if (name === 'awb_number') {
            value = handleChange(value);
        }
        setEditFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    }
    const handleEditSave = async () => {
        const dataToSend = { ...editFormData, asset_type: editFormData.asset_type == true ? 'N' : 'Y' };
        try {
            const res = await withRFSToken.post(EDITULDSTOCK, dataToSend)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg)
                        reloadEdit();
                        handleModalClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const handleModalClose = () => {
        setModalShow(false);
        setEditFormData({});
        onClose();
    };
    return (
        <>{console.log('222', editFormData)}
            <Modal show={modalShow} onHide={handleModalClose} className='addfrom change_type editculm' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit ULD - <span>{editFormData.uld_number}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm='12' className='mb-2'>
                            <Form.Label className='form-label'>Type Code</Form.Label>
                            <Select
                                options={getTypeCodes}
                                onChange={(selected) => {
                                    const updatedData = { ...editFormData, type_code: selected.value };
                                    setEditFormData(updatedData);
                                }}
                                placeholder="Type Code"
                                className='autoslct'
                                name="type_code"
                                value={getTypeCodes.find(option => option.value === editFormData.type_code)}
                            />
                        </Col>
                        <Col sm='12' className='mb-2'>
                            <Form.Label className='form-label'>Serial Number </Form.Label>
                            <Form.Control type="text" value={editFormData.serial_number} name='serial_number' onChange={handleEditChange} />
                        </Col>
                    </Row>
                    <Row >
                        <Col sm='12' className='mb-2'>
                            <Form.Label className='form-label'>Owner Code</Form.Label>
                            <Select
                                options={getOwnerCodes}
                                onChange={(selected) => {
                                    const updatedData = { ...editFormData, owner_code: selected.value };
                                    setEditFormData(updatedData);
                                }}
                                placeholder="Owner Code"
                                className='autoslct'
                                name="owner_code"
                                value={getOwnerCodes.find(option => option.value === editFormData.owner_code)}
                            />
                        </Col>
                        {/* <Col sm='12' className='mb-2'>
                            <Form.Label className='form-label'>Condition Code</Form.Label>
                            <Form.Select aria-label="Default" value={editFormData.condition_code} name="condition_code" onChange={handleEditChange}>
                                {getCondCodes &&
                                    Object.entries(getCondCodes).map((option, index) =>
                                        <option key={index} value={option[0]}>{option[1]}</option>
                                    )
                                }
                            </Form.Select>
                        </Col> */}
                    </Row>
                    <Row >
                        <Col sm='12' className='mb-2'>
                            <Form.Label className='form-label'>Airway Bill</Form.Label>
                            <Form.Control type="text" value={editFormData.awb_number || ''} name='awb_number' maxLength={13} onChange={handleEditChange} />
                        </Col>
                    </Row>
                    <Row >
                        <Col sm='6' className='mb-2'>
                            <Form.Label className='form-label'>Destination</Form.Label>
                            <Select
                                options={getDestination}
                                onChange={(selected) => {
                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                    // const updatedData = { ...formData, destination: selected.value, handler_name: '' };
                                    // setFormData(updatedData);
                                    setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                    setSelectedDestinationId(selectedDestination.station_id);
                                    // setSelectedDestinationHandler(null);
                                    if (selectedDestination.address.length === 1) {
                                        const transformData = { value: selectedDestination.address[0].id, label: selectedDestination.address[0].company_name }
                                        setSelectedDestinationHandler(transformData)
                                        setEditFormData(prevFormData => {
                                            const newFormData = { ...prevFormData, destination_handler: selectedDestination.address[0].id };

                                            return newFormData;
                                        });
                                    } else {
                                        setSelectedDestinationHandler(null);
                                        setEditFormData(prevFormData => {
                                            const newFormData = { ...prevFormData, destination_handler: '' };

                                            return newFormData;
                                        });
                                    }
                                    setEditFormData(prevFormData => {
                                        const newFormData = { ...prevFormData, destination: selected.value };
                                        return newFormData;
                                    });
                                }}
                                placeholder="Destination"
                                className='autoslct'
                                name="destination"
                                value={getDestination.find(option => option.value === editFormData.destination)}
                            />
                        </Col>
                        <Col sm='6' className='mb-2'>
                            <Form.Label className='form-label'>Handler Name</Form.Label>
                            <Select
                                options={destinationHandler.map(handler => ({
                                    value: handler.id,
                                    label: handler.company_name
                                }))}
                                onChange={(selected) => {
                                    // const updatedData = { ...formData, destination_handler: selected.label };
                                    // setFormData(updatedData);
                                    setSelectedDestinationHandler(selected);
                                    setEditFormData(prevFormData => {
                                        const newFormData = { ...prevFormData, destination_handler: selected.value };
                                        return newFormData;
                                    });
                                }}
                                placeholder="Handler Name"
                                className='autoslct'
                                name="destination_handler"
                                // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : null}
                                isDisabled={!destinationHandler.length}
                            />
                        </Col>
                    </Row>
                    <Row >
                        <Col sm='6' className='mb-2'>
                            <Form.Label>Flight Number <span></span></Form.Label>
                            <div className='d-flex op_flight'>
                                <Select
                                    options={getOwnerCodes}
                                    onChange={(selected) => {
                                        // const updatedData = { ...formData, flight: selected.value };
                                        // setFormData(updatedData);
                                        setEditFormData(prevFormData => {
                                            const newFormData = { ...prevFormData, flight_code: selected.value };
                                            return newFormData;
                                        });
                                    }}
                                    placeholder="Flight"
                                    className='autoslct'
                                    name="flight_code"
                                    value={getOwnerCodes.find(option => option.value === editFormData.flight_code)}
                                />
                                <span>-</span>
                                <Form.Control
                                    type="text" className='ms-2'
                                    name='flight_num'
                                    maxLength='8' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                    value={editFormData.flight_num} onChange={handleEditChange}
                                />

                            </div>
                        </Col>
                        <Col sm='6' className='mb-2'>
                            <Form.Label>Flight Date <span></span></Form.Label>
                            <Form.Control type="date" name="flight_date" value={editFormData.flight_date || ''} onChange={handleEditChange} />
                            {/* <Form.Label className='form-label'>Handler Name</Form.Label>
                            <Select
                                options={destinationHandler.map(handler => ({
                                    value: handler.id,
                                    label: handler.company_name
                                }))}
                                onChange={(selected) => {
                                    // const updatedData = { ...formData, destination_handler: selected.label };
                                    // setFormData(updatedData);
                                    setSelectedDestinationHandler(selected);
                                    setEditFormData(prevFormData => {
                                        const newFormData = { ...prevFormData, destination_handler: selected.value };
                                        return newFormData;
                                    });
                                }}
                                placeholder="Handler Name"
                                className='autoslct'
                                name="destination_handler"
                                // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : null}
                                isDisabled={!destinationHandler.length}
                            /> */}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm='12'>
                            <Form.Label className='form-label'>Asset Type</Form.Label>
                            <div className='chart_switch'>
                                <div className="switch6">
                                    <label className="switch6-light">
                                        <input type="checkbox"
                                            name="asset_type"
                                            checked={editFormData.asset_type}
                                            onChange={handleEditChange} />
                                        <span>
                                            <span>Owned</span>
                                            <span>Lease</span>
                                        </span>
                                        <a className="btn btn-primary"></a>
                                    </label>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={handleEditSave}>
                            Update ULD
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default EditUld;